var CommunityComponent = new JS.Class(EditorComponent, {
  initialize: function(containerSelector, communityData) {
    this.container = $(containerSelector);

    this.disabledOption = $(
      '<label for="disableCommunity" class="checkbox"> ' +
        '<input type="checkbox" id="disableCommunity" value="1">' +
        'Disable commenting on this page</label>'
    ).appendTo(this.container);

    this.collapsedOption = $(
      '<label for="collapseCommunity" class="checkbox"> ' +
        '<input type="checkbox" id="collapseCommunity" value="1">' +
        'Collapse comments on this page by default</label>'
    ).appendTo(this.container);

    this.restrictedTopicsOption = $(
      '<label for="restrictTopicsCommunity" class="checkbox"> ' +
        '<input type="checkbox" id="restrictTopicsCommunity" value="1">' +
        'Only allow users with edit permissions to post top level comment threads</label>'
    ).appendTo(this.container);

    this.relatedPagesOption = $(
      '<label for="relatedPagesCommunity" class="checkbox"> ' +
        '<input type="checkbox" id="relatedPagesCommunity" value="1">' +
        'Show related content</label>'
    ).appendTo(this.container);

    this.commentsHeadingInput = $(
      '<div class="span4"><label for="commentsHeading" style="display: inline; font-weight: normal;">' +
        'Comments heading: </label><br/>' +
        '<input type="text" id="commentsHeading" value="Comments">' +
        '<br/>'
    );

    this.commentPlaceholderInput = $(
      '<div class="span4"><label for="commentPlaceholderText" style="display: inline; font-weight: normal;">' +
        'Comment placeholder text: </label><br/>' +
        '<input type="text" id="commentPlaceholderText" value="Write a comment...">' +
        '</div>'
    );

    var data = jQuery.parseJSON(communityData) || {};

    if (data.paidCourse) {
      var commentsRow = $('<div class="row"></div>');

      this.commentsHeadingInput.appendTo(commentsRow);

      if (data.commentsHeading) {
        this.commentsHeadingInput.find('input').val(data.commentsHeading);
      }

      this.commentPlaceholderInput.appendTo(commentsRow);

      if (data.commentPlaceholderText) {
        this.commentPlaceholderInput
          .find('input')
          .val(data.commentPlaceholderText);
      }

      $('<br/>').appendTo(this.container);
      commentsRow.appendTo(this.container);
    }

    if (data.disabled) {
      this.disabledOption.find('input').prop('checked', true);
    }

    if (data.collapsed) {
      this.collapsedOption.find('input').prop('checked', true);
    }

    if (data.relatedPages) {
      this.relatedPagesOption.find('input').prop('checked', true);
    }

    if (data.restrictedTopics) {
      this.restrictedTopicsOption.find('input').prop('checked', true);
    }
  },

  getSaveData: function() {
    var communityObject = {
      disabled: this.disabledOption.find('input:checked').val(),
      collapsed: this.collapsedOption.find('input:checked').val(),
      restrictedTopics: this.restrictedTopicsOption.find('input:checked').val(),
      commentsHeading: this.commentsHeadingInput.find('input').val(),
      commentPlaceholderText: this.commentPlaceholderInput.find('input').val(),
      relatedPages: this.relatedPagesOption.find('input:checked').val(),
    };

    return {
      Community: communityObject,
    };
  },
});
